// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Component } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactInputCheckedEvent, ReactEmptyEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Components
import TableHeader, { TableHeaderBaseFCProps } from './TableHeader'
import { TableSortBtnClickEvent } from '../TableContainer'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface TableHeaderCProps extends TableHeaderBaseFCProps {
    onSort: (value: string) => void
    onSelectAll: (value: boolean) => void
    onSelectAllToggle: () => void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
class TableHeaderContainer extends Component<TableHeaderCProps> {
    render() {
        return (
            <TableHeader
                {...this.props}
                onSelectAllClick={this.handleSelectAllClick}
                onSelectAllChange={this.handleSelectAllChange}
                onSortClick={this.handleSortClick}
            />
        )
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    handleSortClick: TableSortBtnClickEvent = (property) => (event) => {
        this.props.onSort(property)
    }

    handleSelectAllChange: ReactInputCheckedEvent = (event, checked) => {
        this.props.onSelectAll(checked)
    }

    handleSelectAllClick: ReactEmptyEvent = () => {
        this.props.onSelectAllToggle()
    }
}

export default TableHeaderContainer
